import { useToast } from '@melio/penny';
import { useFundingSources } from '@melio/platform-api';
import { forwardRef } from '@melio/platform-utils';
import { useEffect } from 'react';

import { GuestPaymentLayout } from '../../layout';

export type LoadFundingSourcesActivityProps = {
  onDone: (fundingSourceId?: string) => unknown;
  onError?: ErrorFunction;
};

export const LoadFundingSourcesActivity = forwardRef<LoadFundingSourcesActivityProps>(
  ({ onDone, onError, ...props }, ref) => {
    const { data: [fundingSource] = [], isFetched, error } = useFundingSources();
    const toast = useToast();
    useEffect(() => {
      if (isFetched) {
        if (fundingSource) {
          void onDone(fundingSource.id);
        } else if (error) {
          onError?.(error);
          toast({ type: 'error', title: error.message });
        } else {
          onDone();
        }
      }
    }, [isFetched]); // eslint-disable-line react-hooks/exhaustive-deps
    return (
      <GuestPaymentLayout isLoading data-component={LoadFundingSourcesActivity.displayName} {...props} ref={ref} />
    );
  }
);
LoadFundingSourcesActivity.displayName = 'LoadFundingSourcesActivity';
